module.exports = __webpack_public_path__ + "static/media/icon_intern.8e45ee22.svg";